import * as styles from './blogTableOfContents.module.css'
import Link from 'next/link'
import Clickable from 'components/Clickable'
import { useState } from 'react'
import Icon from 'components/Icons/Icon'

export interface tocItem {
  anchor: string,
  level: number,
  text: string,
}

interface Props {
  toc: tocItem[],
  basePath: string,
}

const BlogTableOfContents =(props: Props) => {
  const [isCollapsible, setIsCollapsible] = useState(true)
  const containerHeightPixels = isCollapsible ? 0 : props.toc.length * 40
  return <div className={styles.tocContainer}>
    <div className={styles.blogTableOfContents}>
      <Clickable onClick={() => setIsCollapsible(!isCollapsible)}>
        <div className={styles.title}>
          <span className={isCollapsible ? styles.expandIcon : styles.collapseIcon}>
            <Icon width={10} height={10} icon='rightArrow' />
          </span>
          Table of Contents
        </div>
      </Clickable>
      <div className={styles.items} style={{ maxHeight: `${ containerHeightPixels }px` }}>
        {props.toc.map(item =>
          <div key={item.anchor} style={{ marginTop: item.level === 2 ? '14px' : '8px', marginLeft: `${item.level - 2}rem`, fontSize: `${ 0.85 - 0.05 * item.level}em` }}>
            <Link href={`${props.basePath}#${item.anchor}`}>
              <a dangerouslySetInnerHTML={{ __html: item.text }} />
            </Link>
          </div>
        )}
      </div>
    </div>
  </div>
}

export default BlogTableOfContents
